export default __webpack_public_path__ + "9e5c422c3fd65ff7cbb531f316fcd489.svg";